import { Component, Input, OnInit } from '@angular/core';
import { HeadCount } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-head-count',
  templateUrl: './head-count.component.html',
  styleUrls: ['./head-count.component.css']
})
export class HeadCountComponent implements OnInit {

  @Input() HeadCountData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedHeadCount: { [s: string]: HeadCount } = {};
  HeadCData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {

  }


  onRowEditInit(data: HeadCount) {
    this.clonedHeadCount[data.Id] = { ...data };
    this.DisableExport = true;
  }

  onRowEditSave(data: HeadCount, index: number) {
    if (data.Id > 0) {

      if (this.clonedHeadCount[data.Id].StaffCount != data.StaffCount) {
        this.HeadCountData[this.HeadCountData.length - 1].StaffCount = this.HeadCountData[this.HeadCountData.length - 1].StaffCount - this.clonedHeadCount[data.Id].StaffCount + data.StaffCount;
      }
      if (this.clonedHeadCount[data.Id].ContractorCount != data.ContractorCount) {
        this.HeadCountData[this.HeadCountData.length - 1].ContractorCount = this.HeadCountData[this.HeadCountData.length - 1].ContractorCount - this.clonedHeadCount[data.Id].ContractorCount + data.ContractorCount;
      }
      delete this.clonedHeadCount[data.Id];
    }
    this.DisableExport = Object.keys(this.clonedHeadCount).length > 0 ? true : false;
  }

  onRowEditCancel(data: HeadCount, index: number) {
    this.HeadCountData[index] = this.clonedHeadCount[data.Id];
    delete this.clonedHeadCount[data.Id];
    this.DisableExport = Object.keys(this.clonedHeadCount).length > 0 ? true : false;
  }

  GetHeadCountSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Head Count",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetHeadCountSelectedDetails.bind(this));
  }
  callbackMethodForGetHeadCountSelectedDetails(response){
    if(response.Success)
    this.HeadCData = response.Result;
  }

  Redirect(value,processId)
  {
  //this.router.navigate(['/pob/view-pass-request/'+ value])
  window.open(ConstantsService.URL.APP + ['/pob/view-pass-request/'+value], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('HeadCountTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('D','C');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "HeadCount.xlsx");

  }
  //EOC Pritesh

}
